import type { Translate } from "@/lib/i18n/translate";
import type { HeroModuleKey } from "./hero-types";

/** One feature chip in the hero chip row. */
export type HeroChipDef = {
  readonly label: string;
  readonly key: HeroModuleKey;
};

/** Chip order + label→key map for the public hero feature row. */
export function heroFeatureChips(t: Translate): readonly HeroChipDef[] {
  return [
    { label: t("inbox"), key: "inbox" },
    { label: t("dokumente"), key: "dokumente" },
    { label: t("telefonanlage"), key: "telefon" },
    { label: t("kundenportal"), key: "portal" },
    { label: t("mailings"), key: "serienbrief" },
    { label: t("teamChat"), key: "teamchat" },
    { label: t("stammdaten"), key: "kontakte" },
    { label: t("aufgaben"), key: "aufgaben" },
    { label: t("terminbuchung"), key: "terminbuchung" },
    { label: t("kiAnrufbeantworter"), key: "anrufbeantworter" },
    { label: t("uebergabeformulare"), key: "formulare" },
    { label: t("onlineMeetings"), key: "meeting" },
    { label: t("wissen"), key: "wissen" },
    { label: t("kiAgenten"), key: "agents" },
    { label: t("kalender"), key: "kalender" },
    { label: t("posteingangsScan"), key: "posteingangsscan" },
    { label: t("onlineEtv"), key: "etv" },
    { label: t("app"), key: "mobil" },
    { label: t("buchhaltung"), key: "buchhaltung" },
  ];
}
